import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		inner: 'md:max-w-[62%] md:mx-auto px-2 md:px-4',
	},
})

export type TextHighlightVariants = VariantProps<typeof styles>
